/**
 * @module Footer - Default
 * @description Site Footer
 */
import Link from 'next/link';
import PropTypes from 'prop-types';
import SiteLegal from '@/content-provider/components/SiteLegal';


const defaultLinks = [
  {
    title: 'Privacy Policy',
    href: 'https://frontier.com/corporate/privacy-policy'
  },
  {
    title: 'Terms & Conditions',
    href: '/terms'
  },
  {
    title: 'Accessibility',
    href: '/terms'
  },
  {
    title: 'California Privacy Policy',
    href: 'https://frontier.com/corporate/privacy-policy-california'
  },
  {
    title: 'Connecticut Privacy Policy',
    href: 'https://frontier.com/corporate/privacy-policy-connecticut'
  }
];

/**
 * @function Component
 * @description Default Footer
 */
const Component = ( { ...props } ) => {
  const { links = defaultLinks } = props;

  return (
    <footer id="colophon" className="site-footer footer-region u-theme-light" role="contentinfo">
      <div className="site-footer-primary">
        <nav className="menu footer-menu footer-menu-primary" aria-label="Footer Primary Menu">
          <div className="l-container footer-menu-links">

            { links.map( ( link, index ) => (
              <Link href={ link.href } key={ index } className="link-title">
                { link.title }
              </Link>
            ) ) }

          </div>
        </nav>
      </div>{ /* .site-footer-primary */ }

      <div className="site-footer-secondary">
        <SiteLegal />
        <p className="site-copyright">&copy; { new Date().getFullYear() } Frontier Communications Parent, Inc. All rights reserved.</p>

        { /* Launches cookie consent pop-up (Needs trailing space to avoid hydration error) */ }
        <p id="ot-sdk-btn" className="ot-sdk-show-settings">Do Not Sell or Share My Personal Information </p> { /* eslint-disable-line no-irregular-whitespace */ }
      </div>{ /* .site-footer-secondary */ }
    </footer>
  );
};

Component.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape( {
      title: PropTypes.string,
      href: PropTypes.string
    } )
  )
};

export default Component;
